import React from 'react';
import headerImage from '../content/picnic.jpeg';
import Layout from './layout';
import HeroImage from '../components/HeroImage';

const About = () => {

  return (
    <Layout>
      <HeroImage headerImage={headerImage} title=''/>
      {/* Text Section */}
      <section className="flex-grow px-4 font-gordita  py-10 bg-pink text-center">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 mb-4">About Girls Club</h2>
        <p className="text-gray-600 text-base sm:text-lg max-w-3xl mx-auto">
        With a passion for trying new hobbies and meeting like-minded people, Danni founded Girls Club Teesside to bring people together through fun, welcoming events. By working with local suppliers and venues, she creates experiences designed to help others find their newest hobby.
        <br/>
        <br/>
        Creating a friendly and low-pressure environment, Danni encourages ladies to attend solo in hopes they can meet their new friends.
        </p>
      </section>

    </Layout>
  );
};

export default About;
